const initialState = {
  flashMessages: [],
};

export default initialState;
